<app-integration
    [widgetRef]="widgetRef"
    [integrationInput]="integrationInput"
    (onIntegrate)="onIntegrate($event)"
    [description]="widgetRef.widgetDescription"
></app-integration>
